module.exports={
  // base_url:`http://wellworld.id:12319`,
  // base_url:"https://telin-api.intellivent.id"
  // base_url:"https://telin-api-2.intellivent.id"
};
